import React from 'react';
import { WebsiteName } from '../../App';
import HeroPage from '../Hero/HeroPage';
import TestimonialPost from '../Posts/TestimonialPost';
import testimonialsData from '../../PostData/testimonialsData';

const Testimonials = () => {
    document.title = "Testimonials | " + WebsiteName;

    return (
        <>
            <HeroPage title="People Are Happy"></HeroPage>

            <main>
                {/* Testimonials */}
                <section className="testimonials" id="testimonials">
                    <div className="container">
                        {testimonialsData.map(test => <TestimonialPost testimonial={test} key={test.id}></TestimonialPost>)}
                    </div> {/* Container */}


                    {/* Blog Pagination */}
                    {/* <nav className="blogPagination">
                        <ul className="page-numbers">
                            <li><a className="prev page-numbers pagination" href="/">&lt;</a></li>
                            <li><a className="page-numbers pagination" href="/">1</a></li>
                            <li><span className="page-numbers current pagination">2</span></li>
                            <li><a className="page-numbers pagination" href="/">3</a></li>
                            <li><a className="page-numbers pagination" href="/">4</a></li>
                            <li><a className="page-numbers pagination" href="/">5</a></li>
                            <li><a className="next page-numbers pagination" href="/">&gt;</a></li>
                        </ul>
                    </nav> Blog Pagination */}
                </section> {/* Testimonials */}
            </main>
        </>
    );
};

export default Testimonials;